export default __webpack_public_path__ + "static/flag-no-a5dfdd6229ac65171155160932c3d292.svg";